"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditPage = exports.FormEditPageConfig = exports.CSS = void 0;
var tslib_1 = require("tslib");
var theme_1 = require("../components/theme");
var i18n_1 = require("../i18n");
var mithril_1 = require("../mithril");
var form_designer_1 = require("../modules/form.designer/form.designer");
var services_1 = require("../services");
var store_1 = require("../store");
var page_1 = require("./page");
exports.CSS = {
    container: 'c-FormEdit'
};
var Style = (_a = {},
    _a[exports.CSS.container] = {
        height: '100%',
        width: '80%'
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.FormEditPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.formEdit,
    path: '/form/edit/:version',
    auth: {
        required: true
    }
};
var FormEditPage = /** @class */ (function (_super) {
    tslib_1.__extends(FormEditPage, _super);
    function FormEditPage() {
        return _super.call(this, exports.FormEditPageConfig) || this;
    }
    FormEditPage.prototype.init = function () {
        var _this = this;
        this.formVersion = services_1.Services.Route.params.get('version');
        this.designer = new form_designer_1.FormDesigner();
        this.designer.setEditing(true);
        store_1.AppStore.Form.fetch(this.formVersion)
            .then(function (form) { return _this.designer.setForm(form); })
            .catch(function (e) { return services_1.Services.Log.Logger.error(e); });
    };
    Object.defineProperty(FormEditPage.prototype, "nodes", {
        get: function () {
            if (services_1.Services.Department.current == null) {
                return null;
            }
            if (this.designer == null) {
                this.init();
            }
            var userProfile = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
            if (!services_1.Services.UserProfile.canEditForms(userProfile)) {
                return null;
            }
            if (!store_1.AppStore.Form.exists(this.formVersion)) {
                return (0, mithril_1.m)('div', { className: exports.CSS.container }, (0, i18n_1.Translate)(i18n_1.T.FORM_NOT_FOUND));
            }
            if (this.designer.form == null) {
                return (0, mithril_1.m)('div', { className: exports.CSS.container });
            }
            return (0, mithril_1.m)('div', { className: exports.CSS.container }, this.designer.view());
        },
        enumerable: false,
        configurable: true
    });
    FormEditPage.prototype.onRemove = function () {
        if (this.designer != null) {
            this.designer.onRemove();
            this.designer = null;
        }
    };
    return FormEditPage;
}(page_1.IkePage));
exports.FormEditPage = FormEditPage;
//# sourceMappingURL=form.edit.page.js.map